import React from 'react';
import pick from '../../../utils/operators/pick';
import Text from '../../../Text';
import { classes, st } from '../../Tabs.st.css.js';
class TabItem extends React.Component {
    getItemStyle() {
        const { type, width, itemMaxWidth, item: { minWidth, maxWidth }, alignment, } = this.props;
        const inlineStyle = type === 'uniformSide' && width
            ? { width }
            : type === 'compactSide' && itemMaxWidth
                ? { maxWidth: `${itemMaxWidth}pt` }
                : {};
        if (minWidth) {
            inlineStyle.minWidth = minWidth;
        }
        if (maxWidth) {
            inlineStyle.maxWidth = maxWidth;
        }
        if (alignment) {
            inlineStyle.textAlign = alignment;
        }
        return inlineStyle;
    }
    render() {
        const { item, onItemClick, isActive, dynamicProperties, size } = this.props;
        const containerProps = {
            key: item.id,
            onClick: onItemClick ? () => onItemClick(item) : undefined,
            className: st(classes.tab, { size, active: isActive }),
            style: this.getItemStyle(),
            ...pick(this.props, dynamicProperties),
        };
        return (React.createElement("button", { role: "tab", type: "button", "aria-selected": isActive, "data-active": isActive, "data-hook": item.dataHook, ...containerProps },
            React.createElement(Text, { size: size, className: classes.tabText, weight: "thin", ellipsis: true }, item.title)));
    }
}
export default TabItem;
//# sourceMappingURL=index.js.map